/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Nick } from './images/nick'
import { Tim } from './images/tim'
import { Nathalie } from './images/nathalie'
import { Lisa } from './images/lisa'
import { Cedric } from './images/cedric'
import { SvgBlinker } from '../svgblinker'
import { Link } from '@ta-interaktiv/contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '856252911051'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Meistens liegt Nick einfach nur im Bett</h1>
            <h2>
              Long Covid betrifft in der Schweiz zunehmend auch Kinder. Einige
              können vor Erschöpfung seit Monaten die Schule nicht mehr
              besuchen.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Marc Brupbacher</div>
            <div className='ta updated'>Aktualisiert am 29. April 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Kinder können in erheblichem Mass von Langzeitfolgen nach einer
              milden Covid-Erkrankung betroffen sein, wie unsere nachfolgenden
              Protokolle von fünf Familien zeigen. Im Kanton Zürich und in{' '}
              <Link href='https://www.tdg.ch/une-consultation-post-covid-ouvre-en-pediatrie-648683068084'>
                Genf
              </Link>{' '}
              gibt es seit kurzem schweizweit die ersten drei klinischen
              Anlaufstellen{' '}
              <Link href='https://www.altea-netzwerk.ch/netzwerk/verzeichnis'>
                für Long Covid
              </Link>{' '}
              für Personen bis 18 Jahre. «Wir müssen herausfinden, wie häufig
              Long Covid bei Kindern ist und wie es sich manifestiert», sagt
              Alexander Möller, Leiter Pneumologie am Zürcher Kinderspital.
            </p>
            <p>
              Bisher handle es sich sowohl in Winterthur als auch in Zürich um
              eine relativ kleine Anzahl von Betroffenen, welche das neue
              ambulatorische Angebot nutzten, es sei nicht vergleichbar mit den
              Zahlen bei den Erwachsenen. «Jüngst berichten verschiedene
              Kinderpneumologien in der Schweiz von einigen Fällen. Insofern
              scheint es doch etwas Neues zu sein», so Möller. Andreas Jung,
              Leitender Arzt pädiatrische Pneumologie am Kantonsspital
              Winterthur, bestätigt: «Wenige ältere Kinder sind bisher
              betroffen, die Zuweisungen sind aber leicht zunehmend.»
            </p>
            <div className='hint' style={{ marginBottom: '1em' }}>
              <p>
                Alle Namen wurden zwecks Anonymisierung abgeändert, das Alter
                und die Angabe des Kantons sind jedoch korrekt.
              </p>
            </div>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Nick />} />
            </div>
            <p className='names'>Meistens liegt er einfach nur im Bett</p>
            <div className='info'>Nick (10), Kanton Zürich</div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              Nick kommt am 23. November 2020 mit Schluckweh und Kopfschmerzen
              von der Schule nach Hause. Sein Banknachbar muss in Quarantäne, da
              ein Elternteil positiv auf Corona getestet wurde. Nick ist zehn
              Tage sehr müde und bleibt zu Hause. Die Symptome werden einfach
              nicht besser, die Kopfschmerzen sogar stärker, neue Beschwerden
              wie Schwindel, Hirnnebel, Bauchschmerzen und eine grosse
              Erschöpfung kommen hinzu. Der Kinderarzt beruhigt. Doch es geht
              Nick täglich schlechter. Die Kopfschmerzen hindern ihn nun an
              jeglicher Aktivität. Seine geliebten Comics liegen achtlos neben
              dem Bett, an Hausaufgaben ist nicht zu denken.
            </p>{' '}
            <p>
              Einen Tag lang überzieht ein feiner roter Ausschlag den gesamten
              Oberkörper von Nick, seine Augen sind stark gerötet. Sorgen macht
              sich nach vier Wochen dann auch der Kinderarzt und überweist den
              Zehnjährigen in die Kindernotaufnahme. Ein Hirntumor wurde
              ausgeschlossen, eine Depression auch. Die Untersuchung aller
              Organe und des Blutbildes sind ohne Befund. Die Diagnose kurz vor
              Weihnachten: Long Covid.
            </p>{' '}
            <p>
              Nach fünf Monaten kämpft Nick noch immer mit einer starken Fatigue
              und Kopfschmerzen. Ein Schulbesuch ist nach wie vor
              ausgeschlossen, da er sich zu Hause maximal für fünf Minuten
              konzentrieren kann. Meistens liegt er einfach im Bett.
            </p>{' '}
            <p>
              «Es tut unfassbar weh, sein vorher lebensfrohes Kind so leiden zu
              sehen», sagt die Mutter. Angst machen ihr die Geschichten von
              betroffenen Kindern in Grossbritannien, den USA und in{' '}
              <Link href='https://www.zdf.de/nachrichten/video/panorama-long-covid-bei-kindern-100.html'>
                Schweden
              </Link>
              , welche auch nach mehr als einem Jahr noch nicht gesund sind.
              Starke Medikamente und Osteopathie brachten keine Erfolge. Die
              einzige Therapieform, welche Nick bisher etwas Linderung
              verschafft, ist Neurofeedback, ein computergestütztes
              Hirnwellentraining. Die Kopfschmerzen können so reduziert werden,
              die Erschöpfung ist allerdings hartnäckiger. Die Mutter sagt: «Es
              liegt noch ein unglaublich harter Weg vor uns. Wie lange dieser
              sein wird, kann uns niemand sagen. Doch wir sind voller Hoffnung,
              dass Nick wieder gesund wird.»
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Beschwerden der jungen Patientinnen und Patienten sind relativ
              diffus, aber einheitlich: Kopfschmerzen, grosse Erschöpftheit
              (Fatigue), Muskelschmerzen bei körperlicher Belastung, Atemnot
              beim Treppensteigen, Konzentrationsprobleme, Schwindel,
              Schlafprobleme, Herzrasen. «Manche können sich in der Schule nicht
              richtig konzentrieren und sich nicht am Sportunterricht
              beteiligen, haben viele Fehltage. Natürlich bereitet das den
              Eltern Sorgen und Ängste», sagt Lungenfacharzt Möller.
            </p>
            <p>
              In Winterthur konnten die meisten der jungen Patienten nach
              gewisser Zeit die Schule wieder besuchen. Wobei Jung auch Fälle
              kennt, in welchen eine Beteiligung am Unterricht aufgrund von
              Schwindel längere Zeit erschwert war. «Häufiger sehen wir
              Einschränkungen beim Sport, aber auch in der Freizeit», so der
              Pneumologe. Long-Covid-Ambulanzen für Kinder gibt es mittlerweile
              auch in{' '}
              <Link href='https://www.focus.de/politik/sogar-saeuglinge-sind-betroffen-uni-arzt-warnt-immer-mehr-kinder-und-jugendliche-opfer-von-corona-spaetfolgen_id_13210858.html'>
                Deutschland
              </Link>
              ,{' '}
              <Link href='https://www.br.de/nachrichten/deutschland-welt/schweden-langzeit-covid-krankenstation-fuer-kinder,STyFcav'>
                Schweden
              </Link>{' '}
              und{' '}
              <Link href='https://nyheder.tv2.dk/samfund/2021-02-18-danmark-faar-sin-foerste-senfoelgeklinik-for-coronaramte-boern'>
                Dänemark
              </Link>
              .
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Tim />} />
            </div>
            <p className='names'>
              Er nennt sie <span className='mark'>«</span>
              Metallplatten-Kopfschmerzen<span className='mark'>»</span>
            </p>
            <div className='info'>Tim (10), Kanton Thurgau</div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              Mitte Februar 2021 kam Tim krank von der Schule heim. Er klagte
              über Halsweh und Gliederschmerzen und hatte etwas erhöhte
              Temperatur. Nach einer Woche begann er über Druck im Brustkorb zu
              klagen, worauf ihn sein Hausarzt nach zwei Wochen auf Corona
              testen liess. Der Test war positiv. Während der folgenden zwei
              Wochen fühlte sich Tim manchmal so schwach, dass er sich während
              des Essens mehrmals ins Bett legte und sich ausruhte, bevor er den
              nächsten Bissen nahm.
            </p>
            <p>
              Nach vier Wochen überwies ihn der Hausarzt an die Kinderklinik des
              Kantonsspitals Münsterlingen. Tim hatte immer noch Druck im
              Brustkorb, Husten, Muskelschmerzen und Kopfschmerzen, die so
              heftig waren, dass er sie «Metallplatten-Kopfschmerzen» nennt. Er
              war vollkommen kraftlos.
            </p>
            <p>
              In der Klinik wurden umfangreiche Tests durchgeführt. Nachdem
              andere Krankheiten ausgeschlossen wurden, zeigte ein
              Lungenfunktionstest, dass Tims Lunge für das Minimum an Leistung
              maximal arbeiten muss. Wenn er zwei Minuten auf seinem neuen Velo
              fährt, muss er sich danach für eine Stunde hinlegen. Seit neun
              Wochen sitzt Tim praktisch nur noch auf dem Sofa, ist völlig
              erschöpft, hat Schmerzen und kann die Schule nicht mehr besuchen.
              Auch der Onlineunterricht wurde für ihn zu anstrengend. Tims
              Lehrerin hat grosses Verständnis und unterstützt die Familie, wo
              sie nur kann. «Kürzlich hatten wir ein Gespräch mit der
              Schulleiterin und der Lehrerin. Nach 20 Minuten hatte Tim Mühe,
              die Augen offen zu behalten», beschreibt die Mutter traurig die
              Szene.
            </p>
            <p>
              Wie es weitergeht, weiss die Familie nicht. «Das ist sehr hart für
              uns», sagt die Mutter. In dieser schwierigen Situation sei nicht
              nur die medizinische Unterstützung wichtig, sondern auch der
              Austausch mit anderen betroffenen Familien von Long Covid.
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Angebote am Kantonsspital Winterthur und am Kinderspital
              Zürich umfassen eine ausführliche diagnostische Abklärung.
              Spezialisten unterschiedlicher Fachabteilungen arbeiten eng
              zusammen. Neben dem Blut untersuchen die Ärzte wichtige Organe der
              Kinder. Doch eine gezielte medikamentöse Therapie steht nicht zur
              Verfügung. «Kopfschmerzen können wir medikamentös behandeln.
              Kindern, die nicht mehr regelmässig in die Schule gehen können
              oder in ihrer körperlichen Leistungsfähigkeit stark eingeschränkt
              sind, kann eine Rehabilitation helfen», sagt Möller vom
              Kinderspital. Auch eine psychologische Unterstützung könne im
              Genesungsprozess hilfreich sein.
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Nathalie />} />
            </div>
            <p className='names'>Nach über einem Jahr noch nicht&nbsp;gesund</p>
            <div className='info'>Nathalie (17), Kanton Bern</div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              Ende Januar 2020 erkrankte Nathalie während eines Chorlagers
              schwer an einem Infekt. Sie litt unter hohem Fieber, starkem
              Husten und fühlte sich hundeelend. Damals redete noch niemand von
              Corona. In den folgenden Monaten fühlte sich die Jugendliche nie
              mehr vollständig erholt. Sie litt unter starken Kopfschmerzen,
              bekam einen Ausschlag am Bauch, war ungewohnt kurzatmig, fühlte
              sich erschöpft, und konnte sich schlecht konzentrieren.
            </p>{' '}
            <p>
              Dass etwas gar nicht stimmte mit ihrem Körper, merkte sie erst ein
              halbes Jahr nach der Erkrankung. Als sie mit ihrem Fussballteam
              nach den Sommerferien endlich wieder das Training aufnehmen
              konnte, erlitt sie mehrmals einen Schwächeanfall. Nathalie konnte
              schon beim Einlaufen nicht mehr richtig atmen, ihr ganzer Körper
              wurde kalt und verkrampfte sich.
            </p>{' '}
            <p>
              Nach langen Abklärungen beim Lungen- und Herzspezialisten wurde
              klar, dass sie einen unregelmässigen Herzschlag hatte, unter
              Asthma litt und dass die Leistungen ihrer Lunge und des Herzes
              eingeschränkt waren. Der Hausarzt, der Kardiologe und die
              Lungenspezialistin führen ihre Erkrankung auf Covid zurück.
            </p>{' '}
            <p>
              Das Herz hat sich inzwischen wieder erholt. Aber auch mehr als ein
              Jahr nach der Infektion leidet die Teenagerin noch unter
              Erschöpfung, Konzentrationsstörungen, Schlafproblemen,
              Gemütsschwankungen und Kopfschmerzen. Wenn sie sich zu sehr
              anstrengt, wird sie nach wie vor kurzatmig. Nathalie inhaliert
              täglich mit drei verschiedenen Medikamenten, um die Lungenfunktion
              zu verbessern. Sie geht im Moment mit einem reduzierten Pensum in
              den Unterricht, die Schülerin hat im letzten Jahr viele Stunden
              verpasst. In ihrer Freizeit ruht sie sich meist aus, soziale
              Kontakte hat sie wenig. Nächste Woche wird die 17-Jährige die
              erste Impfung erhalten und hofft, dass es ihr vielleicht dann
              besser geht.
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Wie viele Kinder in der Schweiz nach Covid an Langzeit-Beschwerden
              leiden, weiss niemand. Es gibt dazu keine Daten, kein Register,
              keine Untersuchungen.{' '}
              <Link href='https://www.ons.gov.uk/peoplepopulationandcommunity/healthandsocialcare/conditionsanddiseases/bulletins/prevalenceofongoingsymptomsfollowingcoronaviruscovid19infectionintheuk/1april2021'>
                Eine Studie
              </Link>{' '}
              des britischen Office for National Statistics (ONS) geht davon
              aus, dass in Grossbritannien der Anteil derjenigen, die drei
              Monate nach einer Corona-Infektion noch mindestens ein Symptom
              aufweisen, bei den Zwei- bis Elfjährigen bei 7,4 Prozent liegt.
              Bei den 12- bis 16-Jährigen sind es 8,2 Prozent.
            </p>
            <p>
              Zu noch pessimistischeren Zahlen kam{' '}
              <Link
                href='https://www.medrxiv.org/content/10.1101/2021.01.23.21250375v1'
                allowWordWrap
              >
                eine italienische Studie
              </Link>
              , bisher neben der britischen Untersuchungen die einzige zu diesem
              Thema. Die For­sche­r analysierten den Gesundheitszustand von 129
              Kindern zwischen fünf und 18 Jahren, die an Covid erkrankt waren.
              Mehr als die Hälfte litt auch vier Monate nach der Diagnose noch
              an Spätfolgen, 42 Prozent davon fühlten sich dadurch im Alltag
              eingeschränkt. Die Kinder klagten über die gleichen
              Long-Covid-Symptome, wie sie auch in der Schweiz beobachtet
              werden. Die Ergebnisse müssen aber mit Vorsicht betrachtet werden.
              Die Zahl der Probanden ist sehr klein, es fehlte auch eine
              Kontrollgruppe mit negativ Getesteten zum Vergleich. Womöglich
              hängt ein Teil der geschilderten Symptome nicht mit Covid
              zusammen.
            </p>
            <p>
              Bereits Ende 2020 publizierte ein schwedischer Kinderarzt einen
              <Link href='https://pubmed.ncbi.nlm.nih.gov/33205450'>
                Fallbericht
              </Link>{' '}
              über fünf schwedische Kinder, die an Langzeitsymptomen leiden. Die
              Kinder hatten sechs bis acht Monate nach ihrer akuten
              Covid-Erkrankung immer noch Symptome. Auch wenn sich bei einigen
              die Situation gebessert hatte, so konnte doch keines ganz in die
              Schule zurückkehren.
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Lisa />} />
            </div>
            <p className='names'>
              Gewisse Ärzte nahmen die Symptome nicht ernst
            </p>
            <div className='info'>Lisa (15), Fürstentum Liechtenstein</div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              Es begann mit leichtem Husten Ende Oktober 2020. Der Corona-Test
              war dann positiv. Kurz darauf verlor Lisa Geruchs- und
              Geschmackssinn und entwickelte Atemprobleme. An Weihnachten hatte
              sie aber eigentlich das Gefühl, sich einigermassen erholt zu
              haben. Im Januar kam der Rückfall. Ihr war tagelang übel. Die
              Atmung verschlechterte sich, manchmal musste sie beim Sprechen
              nach jedem Satz nach Luft ringen. Starke Rücken- und Kopfschmerzen
              plagten sie. Die Schule konnte sie während neun Wochen nur noch
              selten besuchen. Weitere Symptome kamen hinzu und wechseln sich
              seither ab: Gelenkschmerzen, Schwindel, Kältegefühl, plötzliches
              Zittern. Auch der Geschmacks- und Geruchssinn spielt wieder
              verrückt. Das meiste Essen schmeckt ihr ungewohnt oder stinkt. Die
              Konzentrationsfähigkeit hat massiv nachgelassen. Lärm oder eine
              unruhige Umgebung mit vielen Menschen verträgt sie schlecht.
            </p>
            <p>
              Unterdessen geht Lisa temporär in eine Time-out-Schule. Ihre Tage
              haben so wieder Struktur bekommen, und sie hat auch wieder mehr
              soziale Kontakte. «Es stresst mich aber, dass ich den verpassten
              Schulstoff nicht zügig aufarbeiten kann und dieses Schuljahr
              wahrscheinlich abschreiben muss», sagt die Jugendliche.
            </p>
            <p>
              Auch ihre Hobbys liegen seit mehr als einem halben Jahr auf Eis:
              kein Reiten, kein Karate, kein Eislaufen, wenig Treffen mit
              Freundinnen. Nun kämpft sie auch mit depressiven Stimmungen.
              Besonders frustrierend: Gewisse Ärzte nahmen ihre Symptome nicht
              ernst. Unterdessen wird Lisa psychologisch betreut. «Einige Leute
              in meinem Umfeld verstehen meine Beschwerden nicht, meinen ich sei
              eine demotivierte und übernächtigte Pubertierende, das ist
              frustrierend», so die 15-Jährige. Mit Akupunktur versucht sie ihre
              Symptome zu lindern. Nach dem Besuch in einer
              Long-Covid-Sprechstunde wartet Lisa nun auf Termine für spezielle
              Ergo- und Physiotherapien.
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Andreas Jung vom Kantonsspital in Winterthur schätzt die
              Häufigkeit von Long Covid bei Kindern momentan noch als selten
              ein. Auch Alexander Möller vom Kispi Zürich spricht von einer
              «sehr geringen Anzahl» Betroffenen. Er betont aber auch: «Wie
              gross die Dunkelziffer ist, wissen wir wohl erst in einem Jahr
              oder noch später.»
            </p>
            <p>
              Die Frage, welche Kinder ein erhöhtes Risiko für Komplikationen
              haben, können die beiden Kinderärzte nicht beantworten. Bei den
              Patienten gebe es kein Muster. Betroffen seien eher Schulkinder
              und Jugendliche, so viel könne man zumindest sagen, die Mehrheit
              sei älter als acht Jahre. Auch über die Ursache von Long Covid ist
              nach wie vor wenig bekannt. Möglich ist, dass sich das Virus nicht
              ganz eliminieren lässt im Körper, es also eine chronische
              Infektion auslöst. Eine andere These besagt, dass Sars-CoV-2 eine
              Auto­immun­erkrankung auslöst.
            </p>
          </div>
        </div>

        <div className='ui text protocol container'>
          <div className='ta text'>
            <div className='svg-wrapper'>
              <SvgBlinker illu={<Cedric />} />
            </div>
            <p className='names'>
              <span className='mark'>«</span>Ich wäre so gerne wieder wie vor
              Covid<span className='mark'>»</span>
            </p>
            <div className='info'>Cédric (11), Kanton Basel-Landschaft</div>
            <div className='hr-theme-slash-2'>
              <div className='hr-line' />
              <div className='hr-icon'>
                <img src={require('./images/virus.svg')} />
              </div>
              <div className='hr-line' />
            </div>
            <p>
              Sein Vater erkrankte im November 2020 an Covid. Trotz
              Schutzmassnahmen und Isolation erwischte es dann fünf Tage später
              auch Cédric. Angefangen hat es mit Hals- und Kopfschmerzen, dann
              stieg das Fieber. Es folgten Übelkeit, Bauchschmerzen und
              Geschmacks- und Geruchsverlust. Nach einer Woche war das Fieber
              weg, und auch die Geschmackssinne kamen rasch wieder zurück.
            </p>
            <p>
              Der Elfjährige ist aber bis heute noch nicht gesund. «Ich wäre so
              gerne wieder wie vor Covid», sagt er. Über fünf Monate nach der
              akuten Erkrankung leidet er immer noch an Schlaf- und
              Konzentrationsstörungen, Nackenschmerzen, Druck auf dem Brustkorb,
              Übelkeit und Muskelschmerzen. «Er sieht aus wie ein Pandabär mit
              seinen schwarzen Augenringen», beschreibt ihn seine Mutter. Cédric
              hat in der Schule seit Covid regelmässig Blackouts, gerade beim
              Schreiben von Prüfungen bereite ihm das grosse Sorgen. «Meine
              Beschwerden und Ängste scheinen in der Schule niemanden zu
              interessieren», sagt Cédric. «Ich wünsche diese Symptome wirklich
              keinem.»
            </p>
            <p>
              Der Bub gibt aber nicht auf, er bewegt sich täglich an der
              frischen Luft, spielt viel mit seinen Freunden, dabei trägt er
              immer eine Schutzmaske. Am Wochenende geht er oft mit seiner
              Familie auf leichte Wanderungen.
            </p>
            <p>
              Auch der 13-jährige Bruder von Cédric leidet an Long Covid. Er ist
              nach so langer Zeit immer noch so müde und erschöpft, dass er
              tagsüber oft auf dem Stuhl einschläft. Trotz massiven Kopf-,
              Muskel- und Gelenkschmerzen versucht auch er täglich, etwas aktiv
              zu sein.
            </p>
          </div>
        </div>

        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Bleibt die bange Frage: Werden die Kinder wieder ganz gesund?
              Beide Mediziner sind optimistisch. Möller sagt, man könne davon
              ausgehen, dass die Kinder wieder ganz gesund werden, Zahlen dazu
              gebe es aber keine. Jung ergänzt: «Bisher sehen wir in der Regel
              spontane Besserungstendenzen, teils über Wochen bis Monate. Ich
              gehe eher davon aus, dass die Betroffenen in der Regel wieder
              genesen.» Der Kinderarzt betont aber auch, dass viele Betroffene
              frustriert seien, weil sich die Beschwerden nur langsam bessern
              würden.
            </p>
            <p>
              In dem besonders stark betroffenen Land Grossbritannien haben sich
              Eltern von Kindern mit Covid-19-Spätfolgen zusammengeschlossen und
              die{' '}
              <Link href='https://www.longcovidkids.org/'>
                Initiative «Long Covid Kids»
              </Link>{' '}
              gegründet. Die vielen Fallbeschreibungen auf der Website zeigen,
              dass selbst nach einem Jahr längst nicht alle Kinder wieder gesund
              geworden sind.
            </p>
            <p>
              Wenn in der Schweiz bald sämtliche Pandemiemassnahmen aufgehoben
              werden, sind nur noch Kinder und Jugendliche dem Coronavirus
              schutzlos ausgeliefert. Für viele wird die Impfung zu spät kommen,
              die meisten von ihnen werden wohl irgendwann einmal mit Sars-Cov-2
              in Kontakt kommen. Je mehr Kinder krank werden, desto mehr Fälle
              mit zum Teil schweren Langzeitfolgen wird es geben. Ist die
              Pädiatrie auf diese Entwicklung vorbereitet? Möller ist
              zuversichtlich: «Ich gehe nicht davon aus, dass wir ein
              Massenphänomen Long Covid bei Kindern und Jugendlichen haben
              werden.»
            </p>
            <div className='hint' style={{ marginTop: '3em' }}>
              <h5>Hilfe für Betroffene</h5>
              <p>
                Private{' '}
                <Link
                  href='https://web.facebook.com/groups/623751351659252/'
                  allowWordWrap
                >
                  Facebook-Gruppe Long Covid Schweiz
                </Link>
                , Beistand und Austausch von Informationen unter Betroffenen.
              </p>
              <p>
                <Link href='https://www.altea-netzwerk.ch/' allowWordWrap>
                  Altea Long-Covid-Netzwerk Schweiz
                </Link>
                , Anlaufstelle mit vielen Adressen und Informationen. Initiiert
                wurde die Plattform von Lunge Zürich, einer
                Non-Profit-Organisation mit dem Ziel, die Lebensqualität von
                Lungenkranken zu verbessern.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text & Recherche', 'Marc Brupbacher'],
          ['Umsetzung', 'Mathias Lutz']
        ]}
      />
    </div>
  )
}
